import React from "react";

/* A briefcase — business hours, as against a clock's bare time. */
export const BriefcaseIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <rect x="3" y="7.5" width="18" height="12.5" rx="2.2"
          stroke="currentColor" strokeWidth="1.7" />
    <path d="M9 7.5V6a1.8 1.8 0 011.8-1.8h2.4A1.8 1.8 0 0115 6v1.5"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M3 12.4h18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export default BriefcaseIcon;
